import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { conceptSelector } from "../../../../../resources/adapters"
import { fetchConcept } from "../../../../../resources/thunks"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"

import Button from "../Button"
import UnavailableLink from "../UnavailableLink"
import { IGlobalActionsController } from "../../../../../../global"

declare let globalActionsController: IGlobalActionsController

interface Props {
    attributes: Record<string, string>
    label: string
    conceptId: number
}

export const CreateInConcept = ({
    attributes,
    label,
    conceptId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const concept = conceptSelector.selectById(resources, conceptId)

    React.useEffect(() => {
        if (!concept) {
            dispatch(fetchConcept(conceptId))
        }
    }, [])

    if (!concept) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (concept.doesExist) {
        const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
            event.stopPropagation()
            // this method opens the CNI with this conceptId
            globalActionsController.createItemInList(concept.id)
        }

        return (
            <Button attributes={attributes} label={label} onClick={onClick} />
        )
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default CreateInConcept
